import { AppConfig } from "@/lib/types/apps.types";

/**
 * Icon and name of the store listing the visitor is on their way to, shown
 * while the redirect is in flight.
 */
export function getAppDisplay(
  os: "ios" | "android" | "web",
  appConfig: AppConfig
): { appIconSrc: string | null; appName: string | null } {
  if (os === "ios") {
    return {
      appIconSrc: appConfig?.app_store_image_url ?? null,
      appName: appConfig?.app_store_app_name ?? null,
    };
  }

  if (os === "android") {
    return {
      appIconSrc: appConfig?.play_store_image_url ?? null,
      appName: appConfig?.play_store_app_name ?? null,
    };
  }

  return {
    appIconSrc:
      appConfig?.app_store_image_url ?? appConfig?.play_store_image_url ?? null,
    appName:
      appConfig?.app_store_app_name ?? appConfig?.play_store_app_name ?? null,
  };
}
